import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RequestFormComponent } from './request-form.component';
import {  ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { CustomInputModule } from "../../shared/components/custom-input/custom-input.module";
import { CustomRadioButtonModule } from "../../shared/components/custom-radio-button/custom-radio-button.module";
import { CustomDatePickerModule } from "../../shared/components/custom-date-picker/custom-date-picker.module";
import { CustomDropdownModule } from "../../shared/components/custom-dropdown/custom-dropdown.module";
import { InitialRouteReportModule } from "./pages/initial-route-report/initial-route-report.module";
import { RouteMapModalComponent } from './pages/route-map-modal/route-map-modal.component';



@NgModule({
    declarations: [
        RequestFormComponent,
        RouteMapModalComponent
    ],
    exports: [
        RequestFormComponent
    ],
    imports: [
    CommonModule,
    ReactiveFormsModule,
    MaterialModule,
    CustomInputModule,
    CustomRadioButtonModule,
    CustomDatePickerModule,
    CustomDropdownModule,
    InitialRouteReportModule
]
})
export class RequestFormModule { }
